import React, { useEffect, useState } from 'react';
import { dealMgmt } from '../../services/dealManagementApi';
import { Badge } from '../../components/ui';

const BADGE = {
  blacklisted: 'danger',
  watchlist: 'warn',
  possible_match: 'warn',
  clear: 'success',
  not_checked: 'neutral',
};

/**
 * Looks up a director ID against the uploaded Excel / register.
 */
export default function DirectorIdLookup({ idNumber, onMatch }) {
  const [state, setState] = useState({ loading: false, result: null, error: '' });

  useEffect(() => {
    const id = String(idNumber || '').trim();
    if (id.length < 5) {
      setState({ loading: false, result: null, error: '' });
      onMatch?.(null);
      return undefined;
    }
    let cancelled = false;
    const t = setTimeout(() => {
      setState(s => ({ ...s, loading: true, error: '' }));
      dealMgmt.lookupDirector(id)
        .then((res) => {
          if (cancelled) return;
          setState({ loading: false, result: res, error: '' });
          onMatch?.(res);
        })
        .catch((e) => {
          if (cancelled) return;
          setState({ loading: false, result: null, error: e.message });
          onMatch?.(null);
        });
    }, 350);
    return () => {
      cancelled = true;
      clearTimeout(t);
    };
  }, [idNumber]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!String(idNumber || '').trim()) return null;

  if (state.loading) {
    return <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 6 }}>Checking register…</div>;
  }
  if (state.error) {
    return <div style={{ fontSize: 12, color: 'var(--danger)', marginTop: 6 }}>{state.error}</div>;
  }
  if (!state.result) return null;

  const r = state.result;
  const badgeKey = r.status || r.screening || 'clear';

  return (
    <div
      style={{
        marginTop: 8,
        padding: '10px 12px',
        borderRadius: 10,
        border: '1px solid var(--border)',
        background: r.status === 'blacklisted'
          ? 'var(--danger-bg)'
          : r.status === 'watchlist'
            ? 'var(--warning-bg)'
            : 'var(--success-bg)',
        fontSize: 12.5,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <strong>{r.found ? (r.full_name || 'Matched') : 'No register match'}</strong>
        <Badge type={BADGE[badgeKey] || 'neutral'}>{r.message || badgeKey}</Badge>
      </div>
      {r.found && r.id_number && (
        <div style={{ color: 'var(--text2)', marginTop: 4 }}>ID {r.id_number}</div>
      )}
      {r.status_notes && (
        <div style={{ color: 'var(--text2)', marginTop: 4 }}>{r.status_notes}</div>
      )}
      {!r.found && (
        <div style={{ color: 'var(--text2)', marginTop: 4 }}>
          Not found in the uploaded director Excel / register — treated as clear.
        </div>
      )}
    </div>
  );
}
